import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loading_service: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Don't show loading for specific endpoints if needed
    // if (request.url.includes('/some-endpoint-to-ignore')) {
    //   return next.handle(request);
    // }

    // Start the loading indicator
    this.loading_service.startLoading();
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Make sure we stop loading even on error
        return throwError(() => error);
      }),
      finalize(() => {
        // Always stop loading in finalize block to ensure it runs
        this.loading_service.stopLoading();
      })
    );
  }
}
